import { ROLES } from 'config';

const homeConfig = ($stateProvider) => {

  'ngInject';

  $stateProvider
    .state('admin_home', {
      url: '/admin/home',
      template: '<app-admin-home></app-admin-home>',
      access: {
        loginRequired: true,
        roles: [ROLES.ADMIN],
      },
    });
};

export default homeConfig;



// WEBPACK FOOTER //
// ./src/modules/admin-home/home.config.js